import { GoatAwkward } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';
import { type NCWSendNoAssetsDrawerProps, useNCWSendNoAssetsDrawer } from '@capsicum/features/nc-wallet/shared';

/**
 * When the user taps the "Send" button on the NCW Home Page but there are no assets, this drawer is opened.
 */
export const NCWSendNoAssetsDrawer = ({ closeModal }: NCWSendNoAssetsDrawerProps) => {
	const { intlText } = useNCWSendNoAssetsDrawer();

	return (
		<GenericDrawer
			buttonText={intlText.closeBtnText}
			description={intlText.description}
			image={GoatAwkward}
			isButtonFullWidth
			testID="ncw-send-noAssets-drawer"
			title={intlText.title}
			onButtonPress={closeModal}
		/>
	);
};
